import { render, staticRenderFns } from "./AllPep.vue?vue&type=template&id=91c22716&scoped=true&"
import script from "./AllPep.vue?vue&type=script&lang=js&"
export * from "./AllPep.vue?vue&type=script&lang=js&"
import style0 from "./AllPep.vue?vue&type=style&index=0&id=91c22716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91c22716",
  null
  
)

export default component.exports